module["exports"] = [
  "####",
  "###",
  "##"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_AU/address/building_number.js
 ** module id = 478
 ** module chunks = 0
 **/